import useToast from "@/hooks/useToast";

// navigator.clipboard is missing outside secure contexts, which lands in the catch too.
export const useCopyLink = () => {
  const { openToast } = useToast();

  const copyLink = async (link) => {
    try {
      await navigator.clipboard.writeText(link);
      openToast("Link copied", "success");
    } catch (error) {
      openToast("Could not copy the link. Please copy it manually.", "danger");
    }
  };

  return { copyLink };
};
